function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
export class Message {
  constructor(id) {
    _defineProperty(this, "initializeFromObject", from => {
      this.properties = _objectSpread(_objectSpread({}, this.properties), from);
    });
    this.id = id;
    this.properties = {};
    const uuidv4 = require('uuid/v4');
    this.messageId = uuidv4();
  }
  addData(key, value) {
    this.properties[key] = value;
  }
  getData(key) {
    let val = this.properties[key];
    if (val) {
      return val;
    }
    console.log('properties = ', this.properties, key);
  }
  copyAllPropertiesOf(from) {
    Object.entries(from.properties).map(_ref => {
      let [key, value] = _ref;
      return this.addData(key, value);
    });
  }
}